<div
    class="share-list-component"
    style="overflow: auto !important"
    fxLayout="column"
    fxLayoutAlign="center center"
>
    @if (ships?.length <= 4) {
        <img src="/images/empty-contacts.svg" alt="" />
    }
    <div
        class="share-list-component__tags gap-4 dsn-scrollbar overflow-y scroll-secondary"
        fxLayout="column"
        fxLayoutAlign="start none"
        fxFlex
        style="max-height: 11vw"
    >
        @for (ship of ships; track $index) {
            <span class="text-10-regular color-text-hint"
                ><i
                    class="fa-solid fa-share color-text-cyan-primary color-text-cyan-active font-size-14 m-right-12"
                    style="vertical-align: middle"
                ></i
                >{{ ship }}</span
            >
        }
    </div>
</div>
